// export const FULLNAME_PATTERN = /^([a-zA-Z'-]+[,.]?[ ]?|[a-zA-Z'-][^\u0000-\u007F]+['-]?)+$/i;
export const FULLNAME_PATTERN = /^\s?([a-zA-Z'-]+[,.]?[ ]+)+[a-zA-Z'-]{1,}\s?$/i;

export const NON_ALPHA_NUMERIC = /[^A-Za-z0-9- ]+/g;

export const SKU_PATTERN = /^\d{1,6}(?:[- ][0-9a-zA-Z]{0,4})*$/i; // pattern 123, 1234-, 123456-U, 123456-UD19-2L

export const USER_NOTIF_STORE = 'upi-user-notifications';

export const ShippingTiers = {
    STANDARD: {
        id: '000001_STANDARD_P_LTL',
        name: 'Standard Shipping (3 Business Days)'
    },
    TWO_DAY: {
        id: '000001_2DAY_A_LTL',
        name: '2 Business Days'
    },
    OVERNIGHT: {
        id: '000001_OVERNIGHT_A_1DA',
        name: 'Next Business Day'
    }
};

export const ShippingTierMap = Object.entries( ShippingTiers ).reduce( ( acc, [, {id, name}] ) => {
    acc[id] = name;
    return acc;
}, {} );

export const RegistrationSteps = {
    HOME: '/',
    HOME_HASH: '#/',
    NEW_OR_EXISTING: '#/newExistingDecision',
    OFFICE_DETAILS: '#/officeDetails',
    REGISTRATION_LOCKED: '#/registrationLocked',
    VERIFY_ACCOUNT: '#/verifyAccount',
    ACCOUNT_VERIFICATION_REQUIRED: '#/accountRequiresVerification',
    ACCOUNT_VERIFIED: '#/accountVerifiedNPI',
    NOT_VALIDATED: '#/notValidated',
    MULTIPLE_ADDRESSES: '#/multipleAddresses'
};

export const RegistrationStepsMap = {
    [RegistrationSteps.HOME]: '1. Register Login Information',
    [RegistrationSteps.HOME_HASH]: '1. Register Login Information',
    [RegistrationSteps.NEW_OR_EXISTING]: '2. New or Existing Account',
    [RegistrationSteps.OFFICE_DETAILS]: '3.a (New) Enter Office Details',
    [RegistrationSteps.REGISTRATION_LOCKED]: 'Registration Locked',
    [RegistrationSteps.VERIFY_ACCOUNT]: '3.a (Existing) Verify Existing Account',
    [RegistrationSteps.ACCOUNT_VERIFICATION_REQUIRED]: '4. Account Pending',
    [RegistrationSteps.ACCOUNT_VERIFIED]: '4. Account Verified',
    [RegistrationSteps.NOT_VALIDATED]: '3.b (New) Choose Address for NPI Verification',
    [RegistrationSteps.MULTIPLE_ADDRESSES]: '3.b (Existing) Multiple Addresses Select Default'
};